import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 8px;
  justify-content: center;
`;
